import * as yup from 'yup';
export const classificationGroupSchema = yup.string().required('required');
export const classificationCategorySchema = yup.string().required('required');
export const classificationActivitySchema = yup.string().required('required');
export const productCategorySchema = yup
    .array()
    .of(yup
    .string()
    .oneOf(['Life', 'Motor', 'NonMotor', 'NoProductCategory'], 'required')
    .nullable())
    .min(1, 'required')
    .required('required');
export const regionSelectionSchema = yup
    .string()
    .oneOf(['P000000001', 'P000000010', 'P000000011', 'P000000012', 'P000000013'], 'required')
    .required('required');
export const requestsCustomerTypeSchema = yup
    .string()
    .oneOf(['CustomerType_Firma', 'CustomerType_Privat'], 'required')
    .required('required');
export const customerTypeSchema = yup
    .array()
    .of(yup
    .string()
    .oneOf(['CustomerType_Firma', 'CustomerType_Privat'], 'required')
    .nullable())
    .min(1, 'required')
    .required('required');
export const partyIdSchema = yup
    .string()
    .nullable()
    .required('required')
    .trim('trim')
    .matches(/^P[0-9]{9}$/, 'wrongFormat');
export const policyIdsSchema = yup
    .array()
    .of(yup.string())
    .nullable()
    .required('required');
export const policyIdsSchemaNonNullable = policyIdsSchema.min(1, 'required');
export const noPartnerFoundSchema = yup.boolean().required('required');
export const noPartnerFoundNotAllowedSchema = yup
    .boolean()
    .test('noPartnerFoundNotAllowed', 'noPartnerFoundNotAllowed', (value) => value !== true);
export const claimNumberSchema = yup.string().nullable();
export const intermediaryAccountNumberSchema = yup
    .string()
    .nullable()
    .max(7, 'max7Chars')
    .matches(/^[0-9]*$/, 'numeric');
export const intermediaryAccountNumberRequiredSchema = intermediaryAccountNumberSchema.required('required');
export const isContactOrCustomerRequestSchema = yup
    .number()
    .nullable()
    .required('required');
